import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { sendBannerClickEvent } from "../../banner/Banner";
import { LanderConfig } from "../../types/LanderConfig";

interface GetDomainButtonProps {
  landerConfig: LanderConfig;
}

export default function GetDomainButton({
  landerConfig,
}: GetDomainButtonProps): ReactElement | null {
  const link = landerConfig.lander?.banner?.link;
  if (!link) return null;
  const bannerType = landerConfig?.lander?.banner?.type;
  return (
    <div id={ "getButton" }>
      <div id={ "getButtonBox" }>
        <a
          id={ "getButtonBoxLink" }
          href={ link }
          onClick={ () => sendBannerClickEvent(bannerType, landerConfig) }
        >
          <FormattedMessage id="GetThisDomainCTA" />
        </a>
      </div>
    </div>
  );
}
